import { useMediaQuery } from '@react-hookz/web';
import Quote from '@/atoms/Quote';
import CardThumb from '@/molecules/CardThumb';
import Carrousel from '@/molecules/Carrousel';
import CustomMarkdown from '@/molecules/CustomMarkdown';
import Thumbnails from '@/molecules/thumbnails';
import SecondaryTitle from '@/molecules/titles/SecondaryTitle';
import { useModal } from 'context/Modal/Context';
import { MODAL_NAME } from 'context/Modal/MODAL_NAME';
import useCardDetailsApi from 'hooks/queries/cards/useCardsDetailsApi';
import { SIZE } from 'types/utils';

const LoreTab = ({ reference }: { reference: string }) => {
  const { lore, illustrations } = useCardDetailsApi(reference);
  const isMobile = useMediaQuery('(max-width: 768px)', { initializeWithValue: false });
  const thumbnails =
    illustrations?.map((url) => {
      return {
        src: url,
        zoom: url,
        alt: '',
      };
    }) || [];
  const { openModal } = useModal();

  return (
    <div className="flex flex-col gap-6 items-center md:items-stretch">
      {!isMobile ? (
        <Thumbnails thumbnails={thumbnails} />
      ) : (
        <Carrousel options={{ gap: '0.75rem' }}>
          {illustrations
            ? illustrations?.map((url: string) => (
                <div key={url} className="w-full flex justify-center">
                  <button onClick={() => openModal(MODAL_NAME.ZOOM, { imagePath: url })} type="button">
                    <CardThumb alt="" imagePath={url} size={SIZE.LG} />
                  </button>
                </div>
              ))
            : []}
        </Carrousel>
      )}
      {lore?.flavorText && <Quote className="self-center">{lore?.flavorText}</Quote>}
      {lore?.texts.map(
        (loreEntryElement) =>
          !!loreEntryElement.text && (
            <div key={loreEntryElement.id}>
              <SecondaryTitle showLine>{loreEntryElement.loreEntryElementType.subject}</SecondaryTitle>
              <CustomMarkdown className="md-regular mt-4">{loreEntryElement.text}</CustomMarkdown>
            </div>
          ),
      )}
    </div>
  );
};

export default LoreTab;
